<template>
  <div>
    <el-dialog
      :title="`會員點數調整- ${editForm.name}`"
      :visible.sync="dialogEditVisibleProp"
      width="80%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @open="open()"
    >
      <el-form ref="editForm" :model="editForm" :rules="rules" label-width="140px" class="demo-ruleForm">
        <div class="createPost-main-container">
          <el-row>
            <el-col :span="12">
              <el-form-item label="調整點數 :" style="margin-bottom: 10px;" prop="value">
                <el-input v-model="editForm.credits" type="text" onkeypress="return( /[?\d]/.test(String.fromCharCode(event.keyCode)))" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="調整屬性:" style="margin-bottom: 20px;" prop="disabled">
                <el-select v-model="editForm.creditAttribute">
                  <el-option
                    v-for="item in creditAttributeOpitons"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" />
            <el-col :span="24">
              <el-form-item label="備註 :" style="margin-bottom: 10px;" prop="value">
                <el-input v-model="editForm.memo" type="textarea" :rows="5" placeholder="請輸入內容" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button type="danger" @click="onSaveEvent($event)">Save</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import BillingResource from '@/api/billing'
const billingResource = new BillingResource()

const defaultEditForm = {
  id: 0,
  name: '',
  credits: 0,
  creditAttribute: 1,
  memo: ''
}
export default {
  name: 'EditDialog',
  props: {
    dialogEditVisibleProp: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      data: null,
      editForm: Object.assign({}, defaultEditForm),
      rules: {},
      creditAttributeOpitons: [
        { 'value': 1, 'label': 'Increase' },
        { 'value': 0, 'label': 'Decrease' }
      ]
    }
  },
  methods: {
    open() {
      this.editForm.id = this.$parent.currentEditId
      this.editForm.name = this.$parent.currentEditName
    },
    onSaveEvent(event) {
      this.sendData()
    },
    async sendData() {
      console.log(this.editForm)
      const { data } = await billingResource.createCredits(this.editForm)
      const actionTitle = '會員點數調整 '
      if (data.code === 0) {
        this.$parent.dialogEditVisible = false
        this.reloadParentData()
        this.$parent.messageNotify(
          actionTitle + this.$parent.errorCodeMessage[data.code]['title'],
          this.$parent.errorCodeMessage[data.code]['message'],
          this.$parent.errorCodeMessage[data.code]['type']
        )
      } else {
        this.$parent.messageNotify(
          actionTitle + this.$parent.errorCodeMessage[data.code]['title'],
          this.$parent.errorCodeMessage[data.code]['message'],
          this.$parent.errorCodeMessage[data.code]['type']
        )
        return false
      }
    },
    handleClose(done) {
      this.resetData()
      this.$parent.dialogEditVisible = false
    },
    reloadParentData() {
      this.$parent.getList()
      this.resetData()
    },
    resetData() {
      this.$refs.editForm.resetFields()
      this.editForm.id = 0
      this.editForm.name = ''
      this.editForm.credits = 0
      this.editForm.creditAttribute = 1
      this.editForm.memo = ''
    }
  }
}
</script>
